<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{station.id != null && station.id.length > 0 ? "Edit Station" : "Add Station"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveStation()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Name <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Name"
                                [formControl]="name" name="name" [(ngModel)]="station.name" />
                        <mat-error *ngIf="name.invalid">Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>CRS Code <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="CRS Code"
                                [formControl]="crsCode" name="crsCode" [(ngModel)]="station.crsCode" />
                                <mat-error *ngIf="crsCode.invalid">CRS Code is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Latitude</mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Latitude"
                                [formControl]="lat" name="lat" [(ngModel)]="station.lat" />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Longitude</mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Longitude"
                                [formControl]="long" name="long" [(ngModel)]="station.long" />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center py-3 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class=" btn-black ">Save </button>&nbsp;&nbsp;                
            </div>
        </div>
    </div>
</form>
